'use strict';

class OfferDraft {
  constructor($scope, $routeParams, $location, $filter, offerService, originatorService, commonService, I18N, Notification, userService) {
    this.$scope = $scope;
    this.$location = $location;
    this.$filter = $filter;
    this.offerService = offerService;
    this.originatorService = originatorService;
    this.commonService = commonService;
    this.I18N = I18N;
    this.Notification = Notification;
    this.userService = userService;

    this.number = $routeParams.number;
  }

  $onInit() {
    this.defaultDate = moment().add(14, 'days').format('YYYY-MM-DD');

    this.defaults = null;

    this.alert = {};
    this.offer = {
      offerDate: moment().format('YYYY-MM-DD'),
      ourReference: null,
      yourReference: null,
      creditDays: 14,
      freeText: null,
      expiryDate: this.defaultDate,
      deliveryDate: this.defaultDate,
      deliveryAddress: {
        address: null,
        zip: null,
        city: null,
        country: 'NORGE'
      },
      recipient: {},
      items: []
    };

    this.productLimit = 18;
    this.totalPrice = 0;

    this.taxEnabled = false;
    this.discount = 0;

    this.countries = ['NORGE'];
    this.commonService.getCountries()
      .then((resp) => {
        this.countries = resp;
      });

    this.originator = {};
    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
        this.originatorForDisplay = angular.copy(this.originator);
        this.updateAccountOnOriginatorForDisplay();
      });

    this.originatorService.settings()
      .then((resp) => {
        this.defaults = resp.data.defaults;
        this.taxEnabled = resp.data.defaults.totalIncludeMva;
      });

    // datepicker
    this.commonService.datePicker({
      field: $('#deliveryDate')[0]
    });

    this.commonService.datePicker({
      field: $('#expiryDate')[0]
    });

    // watch free textarea for changes
    this.$scope.$watchGroup([
      '$ctrl.offer.freeText',
      '$ctrl.productLimit'
    ], () => {
      this.dynamicFreeText();
    });

    this.$scope.$watch('$ctrl.offer.accountNumber', (val, old) => {
      if (val && val !== old) {
        //update accountno on originator
        this.updateAccountOnOriginatorForDisplay();
      }
    });

    this.$scope.$watch('$ctrl.offer.expiryDate', (val) => {
      if (moment(val, 'YYYY-MM-DD').isBefore(moment().format('YYYY-MM-DD'))) {
        this.alert = {
          type: 'warning',
          message: this.I18N.offer.error.pastExpiryDate
        };
      } else {
        this.alert = {};
      }
    });

    this.$scope.$watch('$ctrl.offer.deliveryDate', (val) => {
      if (moment(val, 'YYYY-MM-DD').isBefore(moment().format('YYYY-MM-DD'))) {
        this.alert = {
          type: 'warning',
          message: this.I18N.offer.error.pastDeliveryDate
        };
      } else {
        this.alert = {};
      }
    });

    this.$scope.$watch('$ctrl.offer.deliveryAddress.zip', (val) => {
      if (val && this.offer.deliveryAddress.country === 'NORGE') {
        if (val.length === 4) {
          this.commonService.getCityByPostCode(val)
            .then((resp) => {
              this.offer.deliveryAddress.city = resp.data.city ? resp.data.city : 'OLSO';
            });
        }
      }
    });

    // get selected recipient
    this.$scope.$on('selectedRecipient', (e, val) => {
      if (val) {
        this.offer.recipient = val;

        // update yourRef if empty
        if (this.offer.yourReference === '' || this.offer.yourReference === null) {
          this.offer.yourReference = val.yourReference;
        }

        // update discount if not set
        if (val.discount > 0 && this.offer.items.length) {
          this.discount = val.discount;

          this.alert = {
            type: 'info',
            message: `Rabatten på fakturalinjene er endret til <b>${val.discount}%</b>, standardrabatten for <b>${this.offer.recipient.name}</b>.`
          };

          this.offer.items.forEach((item) => {
            item.discount = val.discount;
            return item;
          });
        }
      } else {
        this.offer.recipient = null;
      }
    });

    // get selected products
    this.$scope.$on('productList', (e, val) => {
      this.offer.items = val;
    });

    this.$scope.$on('productSummary', (e, val) => {
      if (val) {
        this.totalNetPrice = val.net.reduce((a, b) => a + b);
        this.totalTax = val.tax.reduce((a, b) => a + b);
        this.totalPrice = val.total;
      }
    });

    if (this.number && this.number !== 'ny') {
      this.load();
    }
  }

  updateAccountOnOriginatorForDisplay() {
    if (this.offer && this.originatorForDisplay) {
      this.originatorForDisplay.bankAccount.number = this.offer.accountNumber;
    }
  }

  dynamicFreeText() {
    let itemLimit = 19;
    let textLength = this.offer.freeText ? this.offer.freeText.split(/\r\n|\r|\n/).length : 1;

    if (this.offer.freeText !== null) {
      itemLimit = itemLimit - textLength;

      if (itemLimit >= 0) {
        this.productLimit = itemLimit;
      }

      if (itemLimit < 0) {
        $('#freeText').addClass('ng-invalid');
        this.freeTextError = true;
      } else {
        $('#freeText').removeClass('ng-invalid');
        this.freeTextError = false;
      }
    }
  }

  load() {
    if (!isNaN(this.number) && this.$location.hash() === 'kopi') {
      this.offerService.getOffer(this.number)
        .then((resp) => {
          this.offer = resp.data;
        });
    } else if (!isNaN(this.number) && this.$location.hash() !== 'kopi') {
      this.offerService.getDraft(this.number)
        .then((resp) => {
          this.offer = resp.data;
        });
    }
  }

  process(draft = false) {
    if (!draft) {
      if (this.offer.recipient === null || this.$filter('isEmptyObject')(this.offer.recipient) || this.offer.items.length < 1) {
        // error if no recipient and any item
        this.Notification.error(this.I18N.offer.error.noRecipient);

        return;
      } else if (this.$filter('numberify')(this.totalPrice) <= 0) {
        // error if price is 0
        this.Notification.error(this.I18N.offer.error.noPrice);

        return;
      } else if (this.freeTextError) {
        // freetext is too long
        this.Notification.error(this.I18N.offer.error.noDescription);

        return;
      }
    } else {
      if (this.$filter('isEmptyObject')(this.offer.recipient)) {
        delete this.offer.recipient;
      }
    }

    // cleanup items
    if (this.offer.items.length) {
      this.offer.items.forEach((item) => {
        item.unitPrice = this.$filter('defaultValue')(this.$filter('numberify')(item.unitPrice), null);
        item.quantity = this.$filter('defaultValue')(this.$filter('numberify')(item.quantity), null);
        return item;
      }, this);
    }

    // reset offer number when coping
    if (this.$location.hash() === 'kopi') {
      this.offer.number = null;
    } else if (this.number === 'ny') {
      delete this.offer.number;
    }

    this.offerService.saveDraft(this.offer)
      .then((resp) => {
        if (draft) {
          this.$location.path('/tilbud');
        } else {
          this.$location.path(`/tilbud/kladd/${resp.data}/send`);
        }
      })
      .catch(() => this.Notification.error(this.I18N.offer.error.save));
  }

  save() {
    this.process(true);
  }

  send() {
    this.process();
  }

  cancel() {
    this.$location.path('/tilbud');
  }
}

OfferDraft.$inject = ['$scope', '$routeParams', '$location', '$filter', 'offerService', 'originatorService', 'commonService', 'I18N', 'Notification', 'userService'];

const offerDraft = {
  controller: OfferDraft,
  templateUrl: 'offer/draft.html'
};

angular
  .module('SendRegning')
  .component('offerDraft', offerDraft)
  .config(($routeProvider) => {
    $routeProvider
      .when('/tilbud/kladd/:number', {
        title: 'Send tilbud',
        template: '<offer-draft />',
        noSidebar: true,
        overlay: true,
        secure: true
      });
  });
